import { GroupCondition } from '@/api/enums';
import { group, notEqual } from '@/api/helpers';
import { SummaryReportDatatable } from '@/components/reports/datatables';
import { useUsersSummaryReport } from '@/hooks/query';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account/current-account.slice';
import React from 'react';

export const SummaryReportsPage: React.FC = () => {
  const account = useAppSelector(selectCurrentAccount);
  const { isLoading: isSummaryLoading, usersSummaryReport } =
    useUsersSummaryReport(account?.id || '', {
      take: 1,
      skip: 0,
      filters: [
        group(GroupCondition.OR, [
          notEqual('phishingCampaigns', 0),
          notEqual('enrolledCourses', 0),
          notEqual('emailsSent', 0),
        ]),
      ],
    });

  return (
    <SummaryReportDatatable
      showBlank={!usersSummaryReport?.count}
      initialLoading={isSummaryLoading}
    />
  );
};
